export interface AdvangateViewModel {
	content: string;
	isFree: boolean;
}

export const AllAdvantages = [
	createSimpleAdvantage('Общение в чате', true),
	createSimpleAdvantage('Данные в рублях', true),
	createSimpleAdvantage('Данные в иностранных валютах', false),
	createSimpleAdvantage('Полный состав активов', false),
	createSimpleAdvantage('Отсутствие рекламы', false),
	createSimpleAdvantage('Экспорт скринера', false),
	createSimpleAdvantage('Полный отчет рыночных рисков', false)
];

function createSimpleAdvantage(content: string, isFree: boolean): AdvangateViewModel {
	return { content, isFree };
}